module.exports = __webpack_public_path__ + "img/1557614074962976769.27c345e8.png";